import App from "./App.vue"
import router from "./resources/router/index"
import "@/assets/evolution.css"
import { instantiateApp } from "./template"

instantiateApp(App, router)
